<template>
  <div ref="optionsList" class="p-4 md:px-10">
    <div v-if="optionsInStock.length > 0">
      <div
        class="grid grid-cols-4 gap-x-3 gap-y-6 md:grid-cols-6 lg:grid-cols-8"
      >
        <GalleryOptionItem
          v-for="(option, index) in optionsInStock"
          :key="'option-' + index"
          :option="option"
          :is-inside-modal="true"
          :is-active="!!activeOptionId && activeOptionId == option.id"
          @on-click="($event) => $emit('onClick', $event)"
        />
      </div>
    </div>
    <h2
      v-if="optionsOutOfStock.length > 0"
      class="mb-4 mt-10 text-lg font-bold text-gray-darkest"
    >
      {{ t('product.stock.text_oos') }}
    </h2>
    <div
      v-if="optionsOutOfStock.length > 0"
      class="grid grid-cols-4 gap-x-3 gap-y-6 md:grid-cols-6 lg:grid-cols-8"
    >
      <GalleryOptionItem
        v-for="(option, index) in optionsOutOfStock"
        :key="'option-' + index"
        :option="option"
        :is-inside-modal="true"
        :is-active="!!activeOptionId && activeOptionId == option.id"
        @on-click="($event) => $emit('onClick', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

import { useTranslations } from '@/shared/composables/useTranslations.ts';

import { useProductOptionsStore } from '../../shared/pinia/modules/product-options.ts';
import GalleryOptionItem from './GalleryOptionItem.vue';

const { t } = useTranslations();
const store = useProductOptionsStore();

// TODO: change out this loose type with an actual variant declaration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TempLooseVariant = Record<string, any>;

withDefaults(
  defineProps<{
    optionsInStock: TempLooseVariant[];
    optionsOutOfStock: TempLooseVariant[];
    screenSize: number;
    activeOptionId: number | null;
  }>(),
  {
    screenSize: 375,
    activeOptionId: null
  }
);

defineEmits(['onClick']);

const optionsList = ref<HTMLElement | null>(null);

let timeout: number | undefined;

const onScroll = () => {
  store.modalOptionsPosition = optionsList.value?.parentElement?.scrollTop ?? 0;
};

onMounted(() => {
  optionsList.value?.parentElement?.addEventListener('scroll', onScroll, {
    passive: true
  });

  const optionsPosition = store.modalOptionsPosition;
  // NOTE: We need to scroll after modal animation
  timeout = window.setTimeout(() => {
    optionsList.value?.parentElement?.scrollTo({
      left: 0,
      top: optionsPosition
    }); // , behavior: 'smooth'
  }, 200);
});

onBeforeUnmount(() => {
  optionsList.value?.parentElement?.removeEventListener('scroll', onScroll);
  if (timeout) {
    window.clearTimeout(timeout);
  }
});
</script>
